import { render, staticRenderFns } from "./price-market-price.vue?vue&type=template&id=fcd1d40c&scoped=true"
import script from "./price-market-price.vue?vue&type=script&lang=js"
export * from "./price-market-price.vue?vue&type=script&lang=js"
import style0 from "./price-market-price.vue?vue&type=style&index=0&id=fcd1d40c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd1d40c",
  null
  
)

export default component.exports